import React from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Fieldset } from 'primereact/fieldset';

const parseDate = (str) => {
    if (!str) return null;
    const [y, m, d] = str.split('-').map(Number);
    return new Date(y, m - 1, d);
};

const formatDate = (date) => {
    if (!date) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
};

export function TabEventBasicData({ event, onChange, submitted, posterFile, onPosterChange }) {
    return (
        <>
            <div className="field">
                <Fieldset legend="Identificação">
                    <div className="formgrid grid">
                        <div className="field col-12">
                            <label htmlFor="evName">Nome do Evento *</label>
                            <InputText id="evName" value={event.name}
                                onChange={(e) => onChange('name', e.target.value)}
                                className={classNames({ 'p-invalid': submitted && !event.name })} />
                            {submitted && !event.name && <small className="p-error">Obrigatório</small>}
                        </div>
                        <div className="field col-6">
                            <label htmlFor="evLocation">Local</label>
                            <InputText id="evLocation" value={event.location}
                                onChange={(e) => onChange('location', e.target.value)} />
                        </div>
                        <div className="field col-4">
                            <label htmlFor="evCity">Cidade</label>
                            <InputText id="evCity" value={event.city}
                                onChange={(e) => onChange('city', e.target.value)} />
                        </div>
                        <div className="field col-2">
                            <label htmlFor="evState">UF</label>
                            <InputText id="evState" value={event.state}
                                onChange={(e) => onChange('state', e.target.value)} maxLength={2} />
                        </div>
                        <div className="field col-6">
                            <label htmlFor="evStartDate">Data de Início</label>
                            <Calendar id="evStartDate"
                                value={parseDate(event.startDate)}
                                onChange={(e) => onChange('startDate', formatDate(e.value))}
                                dateFormat="dd/mm/yy" showIcon />
                        </div>
                        <div className="field col-6">
                            <label htmlFor="evEndDate">Data de Término</label>
                            <Calendar id="evEndDate"
                                value={parseDate(event.endDate)}
                                onChange={(e) => onChange('endDate', formatDate(e.value))}
                                dateFormat="dd/mm/yy" showIcon />
                        </div>
                        <div className="field col-12">
                            <label htmlFor="evInstructors">Ministrantes</label>
                            <InputText id="evInstructors" value={event.instructors}
                                onChange={(e) => onChange('instructors', e.target.value)}
                                placeholder="Nomes separados por vírgula" />
                        </div>
                        <div className="field col-12">
                            <label htmlFor="evNewsUrl">Link da Notícia</label>
                            <InputText id="evNewsUrl" value={event.newsUrl}
                                onChange={(e) => onChange('newsUrl', e.target.value)} />
                        </div>
                        <div className="field col-12">
                            <label htmlFor="evDescription">Descrição</label>
                            <InputTextarea id="evDescription" value={event.details}
                                onChange={(e) => onChange('details', e.target.value)}
                                rows={5} autoResize />
                        </div>
                    </div>
                </Fieldset>
            </div>
            <div className="field">
                <Fieldset legend="Cartaz">
                    {event.posterKey && (
                        <small className="block mb-2 text-color-secondary">
                            Cartaz atual: {event.posterKey}
                        </small>
                    )}
                    <input type="file" accept="image/*"
                        onChange={(e) => onPosterChange(e.target.files[0] || null)} />
                    {posterFile && (
                        <small className="ml-2" style={{ color: 'var(--green-500)' }}>
                            {posterFile.name}
                        </small>
                    )}
                </Fieldset>
            </div>
        </>
    );
}
